import React from 'react';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import Grid from '@material-ui/core/Grid';
import { CustomButton } from '../Button';
import { CustomTextField } from '../Inputs/CustomTextField';
import { CustomPasswordField } from '../Inputs/CustomPasswordField';
import styles from '../../utils/styles';

const LoginForm = (props) => {
  const classes = styles();

  const { loginLoading } = useSelector((state) => ({
    loginLoading: state.getIn(['app', 'loginLoading'])
  }));

  const {
    values,
    errors,
    touched,
    handleBlur,
    handleChange,
    handleSubmit
  } = props;
  const { email, password } = values;

  const { t } = useTranslation();

  return (
    <Grid
      container
      direction="column"
      justify="center"
      alignItems="center"
    >
      <Grid item className={classes.fieldWrapper}>
        <CustomTextField
          name="email"
          type="email"
          label={t('email')}
          value={email.trim()}
          onBlur={handleBlur}
          onChange={handleChange}
          error={!!touched.email && !!errors.email}
          helperText={touched.email && errors.email ? t(errors.email) : ''}
          fullWidth
        />
      </Grid>
      <Grid item className={classes.fieldWrapper}>
        <CustomPasswordField
          name="password"
          id="password"
          label={t('password')}
          value={password}
          handleChange={handleChange}
          handleBlur={handleBlur}
          error={!!touched.password && !!errors.password}
          helperText={touched.password && errors.password ? t(errors.password) : ''}
          fullWidth
        />
      </Grid>
      <CustomButton
        type="submit"
        variant="contained"
        color="secondary"
        handleClick={() => {
          handleSubmit({ email, password })
        }}
        loading={loginLoading}
        title={t('loginSubmit')}
      />
    </Grid>
  );
};

export default LoginForm;
